import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import {
  buttonTexts,
  createAccountPrompt,
  existingAccountPrompt,
} from './login-email-form.constants';

@Component({
  selector: 'smartflip-login-email-form',
  templateUrl: './login-email-form.component.html',
  styleUrls: ['./login-email-form.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, IonicModule],
})
export class LoginEmailFormComponent implements OnInit {
  @Input() loginForm!: UntypedFormGroup;
  @Input() newAccount: boolean = false; // User is creating an account
  @Input() forgotPassword: boolean = false; // User has forgotten password
  @Input() showPasswordResetConfirmation: boolean = false;
  @Input() resettingPassword: boolean = false;
  @Input() error: string | null = null;
  @Output() newAccountChange: EventEmitter<boolean> = new EventEmitter();
  @Output() forgotPasswordChange: EventEmitter<boolean> = new EventEmitter();
  @Output() loginButtonClicked: EventEmitter<null> = new EventEmitter();
  @Output() forgotPasswordClicked: EventEmitter<string> = new EventEmitter();

  public loginButtonText$: BehaviorSubject<string> = new BehaviorSubject(
    'Log In',
  );
  public forgotPasswordText$: BehaviorSubject<string> = new BehaviorSubject(
    'Forgot your password?',
  );
  public toggleCreateText = '';

  public handleEmailLogin() {
    this.loginButtonClicked.emit();
  }

  public handleForgotPassword() {
    const { email } = this.loginForm.value;

    this.forgotPasswordClicked.emit(email);
  }

  public handleSubmit(event: SubmitEvent) {
    event?.preventDefault();
    console.log('submitted', this.loginForm.value);
  }

  public toggleCreateAccount() {
    this.newAccount = !this.newAccount;
    this.setCreateButtonText();
    this.loginButtonText$.next(this.getLoginButtonText());
    this.newAccountChange.emit(this.newAccount);
  }

  public toggleForgotPassword() {
    this.forgotPassword = !this.forgotPassword;
    this.loginForm.get('')?.enable();
    this.loginForm.get('')?.enable();

    const passwordText = this.forgotPassword
      ? 'Back to Sign in'
      : 'Forgot your password?';

    this.loginButtonText$.next(this.getLoginButtonText());
    this.forgotPasswordText$.next(passwordText);
    this.forgotPasswordChange.emit(this.forgotPassword);
  }

  private setCreateButtonText() {
    this.toggleCreateText = this.newAccount
      ? existingAccountPrompt
      : createAccountPrompt;
  }

  private getLoginButtonText(): string {
    return this.newAccount
      ? buttonTexts.create
      : this.forgotPassword
        ? buttonTexts.reset
        : buttonTexts.login;
  }

  ngOnInit(): void {
    this.setCreateButtonText();
  }
}
